import React, { useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";

const AllLocationsMapModal = ({ show, onHide, activities,day }) => {
    const mapRef = useRef(null);
    const mapInstance = useRef(null);
    const boundsRef = useRef(null);
    const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    useEffect(() => {
        if (show && window.google) {
            initMap();
        } else if (show) {
            loadGoogleMapsScript(() => initMap());
        }
    }, [show]);

    const loadGoogleMapsScript = (callback) => {
        if (document.getElementById("google-maps-script")) {
            callback();
            return;
        }

        const script = document.createElement("script");
        script.id = "google-maps-script";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`;
        script.async = true;
        script.defer = true;
        script.onload = callback;
        document.body.appendChild(script);
    };

    const initMap = () => {
        const map = new window.google.maps.Map(mapRef.current, {
            zoom: 13,
            center: { lat: 45.5017, lng: -73.5673 },
        });

        const bounds = new window.google.maps.LatLngBounds();
        const infoWindow = new window.google.maps.InfoWindow();

        activities.forEach((activity) => {
            if (activity.lat && activity.lng) {
                const position = { lat: activity.lat, lng: activity.lng };
                const marker = new window.google.maps.Marker({
                    position,
                    map,
                    title: activity.name,
                });
                marker.addListener("mouseover", () => {
                    infoWindow.setContent(`<div><strong>${activity.name}</strong></div>`);
                    infoWindow.open(map, marker);
                });
        
                
                marker.addListener("mouseout", () => {
                    infoWindow.close();
                });
                

                marker.addListener("click", () => {
                    map.setZoom(17);
                    map.setCenter(position);
                    infoWindow.setContent(`
                        <div>${activity.name}</div>
                    `);
                    infoWindow.open(map, marker);
                });

                bounds.extend(position);
            }
        });

        map.fitBounds(bounds);
        mapInstance.current = map;
        boundsRef.current = bounds;
    };

    const resetMapView = () => {
        if (mapInstance.current && boundsRef.current) {
            mapInstance.current.fitBounds(boundsRef.current);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Activity Locations For Day {day}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div
                    ref={mapRef}
                    style={{ height: "500px", width: "100%" }}
                />
                <div className="d-flex justify-content-end mt-2">
                    <Button variant="secondary" onClick={resetMapView}>
                        Zoom Out to All
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AllLocationsMapModal;

